import { api } from 'api';
import { showHttpSingleError } from 'api/apiRequest/httpErrorAlert';
import { IHttpError } from 'api/apiRequest/requestTypes';
import { ActionName, PostParams, PutParams, ServerActionName } from 'api/endpoints';
import { EditOrAddResponse } from 'components/UIComponents/EntityTable/EntityTable.types';
import { FetchStatus } from 'types/fetch-status.types';

type ActionResponse = EditOrAddResponse<ActionName>;

export const apiClaimActionNames = {
  post: async (params: PostParams): Promise<ActionResponse> => {
    const { data, error } = await api.actionNames.postNames(params);
    if (error) {
      const message = parseErrorMessage(error) || 'Error creating action name';
      return { type: FetchStatus.Error, error: { message } };
    }

    const item = toActionName(data!);
    return { type: FetchStatus.Done, item };
  },

  put: async (params: PutParams): Promise<ActionResponse> => {
    const { data, error } = await api.actionNames.putNames(params);
    if (error) {
      const message = parseErrorMessage(error) || 'Error saving claim action name';
      showHttpSingleError({ ...error, message });
      return { type: FetchStatus.Error, error: { message } };
    }

    const item = toActionName(data!);
    return { type: FetchStatus.Done, item };
  },
};

type ClaimUpdateErrorDetails = {
  errorMessage: string;
}[];

const parseErrorMessage = (error: IHttpError): string => {
  const errorBody = (error?.body as ClaimUpdateErrorDetails)
    ?.map((r) => r.errorMessage)
    .filter((r) => !!r)
    .join(', ');

  return errorBody || error?.message || '';
};

export const toActionName = (sa: ServerActionName): ActionName => ({
  id: sa.id,
  hearingDate: sa.hearingDate,
  name: sa.actionName,
  typeId: sa.resolutionTypeId,
  substatusId: sa.actionSubStatusId,
});
